export default {
  root: {
    display: 'flex',
    margin: '10px 0'
  },
  tabs: {
    borderBottom: '1px solid #EBEDF2',
    marginBottom: '10px',
    '& .MuiTabs-flexContainer': {
      justifyContent: 'center'
    }
  },
  additionalGrid: {
    display: 'flex',
    padding: '5px 0',
    gap: '20px',
    justifyContent: 'space-around'
  },
  additionalColumn: {
    display: 'flex',
    flexDirection: 'column'
  },
  additionalBox: {
    padding: '2px 0'
  },
  additionalBoxLabel: {
    fontWeight: '600',
    fontSize: '12px'
  },
  tabContent: {
    minHeight: '450px',
    width: '790px'
  },
  autoCreatedInfo: {
    padding: '8px 10px',
    fontSize: '12px',
    color: '#646c9a',
    fontStyle: 'italic'
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    borderTop: '1px solid #EBEDF2',
    padding: '10px',
    '& button': {
      margin: '10px'
    }
  }
};

export const customStyles = {
  input: {
    textfield: {
      width: '245px'
    },
    label: {
      paddingLeft: '20px'
    }
  },
  select: {
    value: {
      width: '245px'
    },
    label: {
      paddingLeft: '20px'
    }
  },
  checkbox: {
    root: {
      width: '400px'
    },
    label: {
      width: '260px'
    }
  },
  checkboxUser: {
    root: {
      paddingLeft: '20px',
      width: '300px'
    },
    label: {
      width: '250px'
    }
  }
};

export const customStylesExchange = {
  checkbox: {
    root: {
      width: '175px'
    },
    label: {
      width: '120px'
    }
  },
  input: {
    root: {
      width: '300px',
      marginRight: '0',
      marginLeft: '20px'
    }
  }
};
